// extracted by mini-css-extract-plugin
export default {"container":"ProtestMap_container__-4TpV","title":"ProtestMap_title__qBoVZ","map":"ProtestMap_map__eUVSs"};